import React, { useMemo } from 'react';

import { CheckList, SaveFile } from '../../shared/icons';
import { Tile, TileSelect } from '../../shared/tile-select/TileSelect';
import { PortfolioAnalysisPage } from './store';

interface PortfolioAnalysisSelectProps {
    selectTile: (view: PortfolioAnalysisPage) => void;
}

export const PortfolioAnalysisSelect: React.FC<PortfolioAnalysisSelectProps> = ({ selectTile }) => {

    const portfolioAnalysisTiles: Tile[] = useMemo(() => [
        {
            label: PortfolioAnalysisPage.SURVEY,
            description: ['Ask a new question about your portfolio'],
            onClick: () => selectTile(PortfolioAnalysisPage.SURVEY),
            testId: 'portfolio-analytics-survey',
            icon: CheckList
        },
        {
            label: PortfolioAnalysisPage.TEMPLATES,
            description: ['Manage all of your existing templates'],
            onClick: () => selectTile(PortfolioAnalysisPage.TEMPLATES),
            testId: 'portfolio-analytics-template',
            icon: SaveFile
        }
    ], [selectTile]);

    return (
        <TileSelect testId='playbook' tiles={portfolioAnalysisTiles} />
    );
};
